import { CollaboratorPerceptionSettingsResponse } from "app/types/Ajustes";
import { PerceptionPost, PerceptionResponse } from "app/types/perceptions";
import axios from "axios";

const NET_URL = process.env.REACT_APP_API_NET;

export const postPerceptions = async (body: PerceptionPost) => {
    return axios.post(`${NET_URL}CollaboratorPerception`, body);
};

export const postPerceptionsSecondRoster = async (body: PerceptionPost) => {
    return axios.post(`${NET_URL}CollaboratorPerceptionSecondRoster`, body);
};

export async function getCollaboratorPerceptions(collaboratorId: number | string | undefined) {
    const data = await axios.get<PerceptionResponse>(`${NET_URL}CollaboratorPerception/${collaboratorId}/collaborator`);
    return data.data.data;
};

export async function getCollaboratorPerceptionsSettings(collaboratorId: number | string | undefined) {
    const data = await axios.get<CollaboratorPerceptionSettingsResponse>(`${NET_URL}CollaboratorPerception/${collaboratorId}/collaborator`);
    return data.data.data;
};

export async function getCollaboratorPerceptionsSecondRosterSettings(collaboratorId: number | string | undefined, periodId: number | string | undefined) {
    try {
        const data = await axios.get<CollaboratorPerceptionSettingsResponse>(`${NET_URL}CollaboratorPerceptionSecondRoster/${collaboratorId}/${periodId}/collaborator`);
        return data.data.data;
    } catch (err : any) {
        // console.error("Error fetching second roster collaborator", err.status);
        return [];
    }
};

export const putPerceptions = async (id: number, body: any) => {
    return axios.put(`${NET_URL}CollaboratorPerception/${id}`, body);
};

export const deleteCollaboratorPerception = async (id: number) => {
    return axios.delete(`${NET_URL}CollaboratorPerception/${id}`);
};

export const deleteCollaboratorPerceptionSecondRoster = async (id: number) => {
    return axios.delete(`${NET_URL}CollaboratorPerceptionSecondRoster/${id}`);
};